import { Check, Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import type { TranslateFn } from "../types";
import { toTestId } from "../utils/catalog";

type ProjectResolutionListProps = {
  t: TranslateFn;
  emails: string[];
  addingToProject: Record<string, boolean>;
  resolvedProjectEmails: Record<string, boolean>;
  disabled?: boolean;
  onAddToProject: (email: string) => void;
  onRemoveEmail: (email: string) => void;
};

const ProjectResolutionList = ({ t, emails, addingToProject, resolvedProjectEmails, disabled = false, onAddToProject, onRemoveEmail }: ProjectResolutionListProps) => {
  if (!emails.length) return null;
  return (
    <div className="mt-3 space-y-2">
      {emails.map((email) => {
        const isAdding = addingToProject[email];
        const isAdded = resolvedProjectEmails[email];
        return (
          <div key={email} className="flex min-w-0 items-center gap-2">
            <div className={`flex min-h-11 min-w-0 flex-1 items-center justify-between gap-2 rounded-md p-1 ${isAdded ? "bg-secondary" : "bg-muted"}`}>
              <div className="flex min-w-0 items-center gap-2 px-1">
                {isAdded ? <Check aria-hidden="true" className="size-4 shrink-0" /> : <Plus aria-hidden="true" className="size-4 shrink-0 text-muted-foreground" />}
                <span className="truncate text-sm" dir="ltr">{email}</span>
              </div>
              {isAdded ? <span className="shrink-0 px-2 text-sm">{t("aiCatalog.shareDialog.added")}</span> : (
                <Button type="button" variant="ghost" data-testid={`ai-catalog-share-add-to-project-${toTestId(email)}`} onClick={() => onAddToProject(email)} disabled={disabled || isAdding} className="h-9 min-w-27.5">
                  {isAdding ? <><Spinner className="size-4" />{t("aiCatalog.shareDialog.adding")}</> : t("aiCatalog.shareDialog.addToProject")}
                </Button>
              )}
            </div>
            <Button type="button" variant="ghost" size="icon-lg" data-testid={`ai-catalog-share-resolve-email-${toTestId(email)}`} aria-label={`${t("common.remove")} ${email}`} onClick={() => onRemoveEmail(email)} disabled={disabled || isAdding} className="bg-muted hover:bg-secondary">
              <X aria-hidden="true" className="size-4" />
            </Button>
          </div>
        );
      })}
    </div>
  );
};

export default ProjectResolutionList;
